import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import ClassificationInformationsSelect from "@/components/ClassificationInformationsSelect.vue";
import { useValidateProps } from "@/composables/fields";
import { dbEnums } from "@/types/enums/dbEnums";
import { DraftStartupperDto } from "@api/draft-startupper-dto";
import { PropType, computed } from "vue";
import { BusinessIdeaFieldCategoryMap } from "..";
import { isMobileReactive } from "@/helpers";
import Field from "../../Field.vue";
import FormFields from "../../FormFields.vue";
import FormSection from "../../FormSection.vue";
import FormSectionHeader from "../../FormSectionHeader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StartupperFormBusinessIdeaBackgroundFields',
  props: {
	fieldsMap: {
		type: Object as PropType<BusinessIdeaFieldCategoryMap>,
		required: true,
	},
	modelValue: {
		type: Object as PropType<DraftStartupperDto>,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const fields = dbEnums.BusinessIdeaFields;

const props = __props;

const emit = __emit;

const formDataComputed = computed({
	get() {
		return props.modelValue;
	},
	set(v) {
		emit("update:modelValue", v);
	},
});

const validateProps = useValidateProps();

return (_ctx: any,_cache: any) => {
  const _component_HakoTextArea = _resolveComponent("HakoTextArea")!
  const _component_HakoRadio = _resolveComponent("HakoRadio")!
  const _component_HakoInput = _resolveComponent("HakoInput")!

  return (_openBlock(), _createBlock(FormSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FormSectionHeader, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("startupperForm.sectionHeaders.businessIdeaBackgroundInfo")), 1)
            ]),
            _: 1
          })
        ]),
        (__props.fieldsMap.Basic)
          ? (_openBlock(), _createBlock(FormFields, {
              key: 0,
              fields: __props.fieldsMap.BackgroundInfo!.fields
            }, {
              [_unref(fields).EducationClassification]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.educationAndQualificationLevelId"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(ClassificationInformationsSelect, {
                      valueSingle: formDataComputed.value.educationAndQualificationLevel,
                      "onUpdate:valueSingle": _cache[0] || (_cache[0] = ($event: any) => ((formDataComputed.value.educationAndQualificationLevel) = $event)),
                      valueSingleId: formDataComputed.value.educationAndQualificationLevelId,
                      "onUpdate:valueSingleId": _cache[1] || (_cache[1] = ($event: any) => ((formDataComputed.value.educationAndQualificationLevelId) = $event)),
                      infoTable: "EducationAndQualificationLevels",
                      translationsTable: "EducationAndQualificationLevelTranslations",
                      translationProperty: "name",
                      ajax: false,
                      style: {"max-width":"750px"}
                    }, null, 8, ["valueSingle", "valueSingleId"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).EducationDescription]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.educationDescription"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.educationDescription,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formDataComputed.value.educationDescription) = $event)),
                      id: elementId
                    }, null, 8, ["modelValue", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).EmploymentClassification]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.employmentStatusId"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(ClassificationInformationsSelect, {
                      valueSingle: formDataComputed.value.employmentStatus,
                      "onUpdate:valueSingle": _cache[3] || (_cache[3] = ($event: any) => ((formDataComputed.value.employmentStatus) = $event)),
                      valueSingleId: formDataComputed.value.employmentStatusId,
                      "onUpdate:valueSingleId": _cache[4] || (_cache[4] = ($event: any) => ((formDataComputed.value.employmentStatusId) = $event)),
                      infoTable: "EmploymentStatuses",
                      translationsTable: "EmploymentStatusTranslations",
                      translationProperty: "name",
                      ajax: false,
                      style: {"max-width":"500px"}
                    }, null, 8, ["valueSingle", "valueSingleId"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).EmploymentDescription]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.employmentDescription"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.employmentDescription,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formDataComputed.value.employmentDescription) = $event)),
                      id: elementId
                    }, null, 8, ["modelValue", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).WorkExperienceDescription]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.workExperienceDescription"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.workExperienceDescription,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formDataComputed.value.workExperienceDescription) = $event)),
                      id: elementId
                    }, null, 8, ["modelValue", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).Schools]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.schools"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.schools,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formDataComputed.value.schools) = $event)),
                      id: elementId
                    }, null, 8, ["modelValue", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).IsFullTime]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.isFullTime"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_HakoRadio, {
                      value: true,
                      inline: "",
                      name: "isFullTime",
                      modelValue: formDataComputed.value.isFullTime,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formDataComputed.value.isFullTime) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("businessidea.fulltime")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_HakoRadio, {
                      value: false,
                      inline: "",
                      name: "isFullTime",
                      modelValue: formDataComputed.value.isFullTime,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formDataComputed.value.isFullTime) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("businessidea.parttime")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_HakoRadio, {
                      value: null,
                      inline: "",
                      name: "isFullTime",
                      modelValue: formDataComputed.value.isFullTime,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formDataComputed.value.isFullTime) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("generic.noChoice")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).HeardFromUs]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.heardFromUsId"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(ClassificationInformationsSelect, {
                      valueSingle: formDataComputed.value.heardFromUs,
                      "onUpdate:valueSingle": _cache[11] || (_cache[11] = ($event: any) => ((formDataComputed.value.heardFromUs) = $event)),
                      valueSingleId: formDataComputed.value.heardFromUsId,
                      "onUpdate:valueSingleId": _cache[12] || (_cache[12] = ($event: any) => ((formDataComputed.value.heardFromUsId) = $event)),
                      infoTable: "HeardFromUs",
                      translationsTable: "HeardFromUsTranslations",
                      translationProperty: "name",
                      ajax: false,
                      style: {"max-width":"750px"}
                    }, null, 8, ["valueSingle", "valueSingleId"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).HeardFromUsWhere]: _withCtx(({ field }) => [
                (formDataComputed.value.heardFromUsId == -10)
                  ? (_openBlock(), _createBlock(Field, {
                      key: 0,
                      field: field,
                      propertyPath: "draftStartupperData.heardFromUsWhere"
                    }, {
                      default: _withCtx(({ elementId }) => [
                        _createVNode(_component_HakoInput, {
                          modelValue: formDataComputed.value.heardFromUsWhere,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formDataComputed.value.heardFromUsWhere) = $event)),
                          id: elementId
                        }, null, 8, ["modelValue", "id"])
                      ]),
                      _: 2
                    }, 1032, ["field"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["fields"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})